// @ts-strict-ignore
import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {FEATURES} from './util';
import {template} from './template';
import css from './index.inline.styl';

export class UpsellPopup extends Component<EmptyObj> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      feature: {type: `string`, enum: Object.values(FEATURES)},
      open: `boolean`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      helpers: {
        handleModalChange: (ev) => this.dispatchEvent(new CustomEvent(`change`, {detail: ev.detail})),
      },
    };
  }
}

export const UpsellPopupEl = defineAndMakeJsxFactory(`mp-upsell-popup`, UpsellPopup);
export const UpsellPopupReact = panel2react(`mp-upsell-popup`, UpsellPopup);
